import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Tabs, Tab, Col } from 'react-bootstrap';

import { BusSchedDocuments } from './BusSchedDocuments';
import { BusMapDocuments } from './BusMapDocuments';
import { TitleRow } from '../../TitleRow';
import { SearchBar } from '../../SearchBar';

export class ListDocuments extends Component {
    static contextTypes = {
        selectApp: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            render: {
                tab: "bussched",
                filter: ""
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
    }

    // ----------------------

    onSearch(filter) {
        const { render } = this.state;

        render.filter = filter;

        this.setState({
            render: render
        });
    }

    onSelectTab(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    // ----------------------

    renderBusSchedDocuments(filter) {
        const { generatorConfigs } = this.props;

        return (
            <BusSchedDocuments 
                generatorConfigs={generatorConfigs}
                filter={filter} />
        );
    }

    renderBusMapDocuments(filter) {
        const { generatorConfigs } = this.props;

        return (
            <BusMapDocuments 
                generatorConfigs={generatorConfigs}
                filter={filter} />
        );
    }

    renderTabs() {
        const { render } = this.state;

        return (
            <div className="tab-with-options">
                <Tabs id="datamanger_tabs" activeKey={render.tab} onSelect={(a) => this.onSelectTab(a)}>
                    <Tab eventKey="bussched" key="bussched" title="Horários à Paragem">
                        {this.renderBusSchedDocuments(render.filter)}
                    </Tab>
                    <Tab eventKey="busmap" key="busmap" title="Mapas Esquemáticos">
                        {this.renderBusMapDocuments(render.filter)}
                    </Tab>
                </Tabs>
            </div>
        );
    }

    render() {
        return (
            <div>
                <TitleRow title="Documentos Gerados" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>&nbsp;</Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                <div className="margin-top-15">
                    {this.renderTabs()}
                </div>
            </div>
        );
    }
}
